module.exports = __webpack_public_path__ + "img/g2.f78456f4.png";